<template>
    <div class="flex items-start my-2 ml-4">
        <div class="absolute flex items-center h-3">
            <input
                id="comments"
                type="checkbox"
                :checked="value"
                @change="$emit('input', $event.target.checked)"
                class="w-4 h-4 mt-2 text-blue-600 transition duration-150 ease-in-out border-gray-500 form-checkbox border-1"
            />
        </div>
        <div class="ml-6 text-xs leading-5">
            <label for="comments" class="font-medium text-gray-600">{{
                label
            }}</label>
            <!-- <p class="text-gray-500">
        Get notified when someones posts a comment on a posting.
      </p> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            required: true
        }
    },
    methods: {}
};
</script>

<style></style>
